import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrandingLandingComponent } from './branding-landing/branding-landing.component';
import { routeConfig } from '../shared/utilities/pages-config';

const routes: Routes = [
  {
    path:  routeConfig.landing.name,
    component: BrandingLandingComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrandingLandingRoutingModule { }
